var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9399 29.2693L36 34.3283L34.3283 36L29.2693 30.9399C27.3869 32.4489 25.0456 33.2696 22.6331 33.2662C16.7636 33.2662 12 28.5025 12 22.6331C12 16.7636 16.7636 12 22.6331 12C28.5025 12 33.2662 16.7636 33.2662 22.6331C33.2696 25.0456 32.4489 27.3869 30.9399 29.2693ZM28.5699 28.3927C30.0693 26.8507 30.9066 24.7838 30.9033 22.6331C30.9033 18.0644 27.2018 14.3629 22.6331 14.3629C18.0644 14.3629 14.3629 18.0644 14.3629 22.6331C14.3629 27.2018 18.0644 30.9033 22.6331 30.9033C24.7838 30.9066 26.8507 30.0693 28.3927 28.5699L28.5699 28.3927Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.eb6b3408ff83d156d9d7aebbb4bbebfe.svg";
export { ForwardRef as ReactComponent };